import React from 'react';
import { CheckIcon, CheckCircle2Icon } from 'lucide-react';
export function BeneficiosIdeal() {
  return <section id="beneficios" className="py-5 sm:py-14 bg-[#0a1628] border-t border-gray-800" data-id="element-30">
      <div className="max-w-5xl mx-auto px-3 sm:px-6" data-id="element-31">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-8" data-id="element-32">
          <div className="bg-[#1e293b]/50 p-3 sm:p-6 rounded-xl border border-gray-700/50" data-id="element-33">
            <h3 className="text-base sm:text-2xl font-bold text-white mb-2 sm:mb-5 border-b border-gray-700 pb-2 sm:pb-3" data-id="element-34">
              Este kit es ideal para:
            </h3>
            <ul className="space-y-1.5 sm:space-y-3" data-id="element-35">
              <li className="flex items-start" data-id="element-36">
                <div className="flex-shrink-0 bg-blue-500/20 rounded-full p-0.5 sm:p-1 mr-2 mt-0.5" data-id="element-37">
                  <CheckIcon className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-blue-400" strokeWidth={3} data-id="element-38" />
                </div>
                <span className="text-xs sm:text-base text-gray-200" data-id="element-39">
                  Docentes de Lengua y Literatura de secundaria
                </span>
              </li>
              <li className="flex items-start" data-id="element-40">
                <div className="flex-shrink-0 bg-blue-500/20 rounded-full p-0.5 sm:p-1 mr-2 mt-0.5" data-id="element-41">
                  <CheckIcon className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-blue-400" strokeWidth={3} data-id="element-42" />
                </div>
                <span className="text-xs sm:text-base text-gray-200" data-id="element-43">
                  Profesores que trabajan en varias instituciones
                </span>
              </li>
              <li className="flex items-start" data-id="element-44">
                <div className="flex-shrink-0 bg-blue-500/20 rounded-full p-0.5 sm:p-1 mr-2 mt-0.5" data-id="element-45">
                  <CheckIcon className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-blue-400" strokeWidth={3} data-id="element-46" />
                </div>
                <span className="text-xs sm:text-base text-gray-200" data-id="element-47">
                  Docentes que buscan orden y estructura anual
                </span>
              </li>
              <li className="flex items-start" data-id="element-48">
                <div className="flex-shrink-0 bg-blue-500/20 rounded-full p-0.5 sm:p-1 mr-2 mt-0.5" data-id="element-49">
                  <CheckIcon className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-blue-400" strokeWidth={3} data-id="element-50" />
                </div>
                <span className="text-xs sm:text-base text-gray-200" data-id="element-51">
                  Educadores que quieren material listo para aplicar
                </span>
              </li>
              <li className="flex items-start" data-id="element-52">
                <div className="flex-shrink-0 bg-blue-500/20 rounded-full p-0.5 sm:p-1 mr-2 mt-0.5" data-id="element-53">
                  <CheckIcon className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-blue-400" strokeWidth={3} data-id="element-54" />
                </div>
                <span className="text-xs sm:text-base text-gray-200" data-id="element-55">
                  Estudiantes de profesorado / formación docente
                </span>
              </li>
            </ul>
          </div>

          <div className="bg-[#1e293b]/50 p-3 sm:p-6 rounded-xl border border-gray-700/50" data-id="element-56">
            <h3 className="text-base sm:text-2xl font-bold text-white mb-2 sm:mb-5 border-b border-gray-700 pb-2 sm:pb-3" data-id="element-57">
              Beneficios del Kit
            </h3>
            <ul className="space-y-1.5 sm:space-y-3" data-id="element-58">
              <li className="flex items-start" data-id="element-59">
                <div className="flex-shrink-0 bg-green-500/20 rounded-full p-0.5 sm:p-1 mr-2 mt-0.5" data-id="element-60">
                  <CheckCircle2Icon className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-[#16a34a]" strokeWidth={3} data-id="element-61" />
                </div>
                <span className="text-xs sm:text-base text-gray-200 font-medium" data-id="element-62">
                  Material organizado por ejes centrales de Lengua y Literatura
                </span>
              </li>
              <li className="flex items-start" data-id="element-63">
                <div className="flex-shrink-0 bg-green-500/20 rounded-full p-0.5 sm:p-1 mr-2 mt-0.5" data-id="element-64">
                  <CheckCircle2Icon className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-[#16a34a]" strokeWidth={3} data-id="element-65" />
                </div>
                <span className="text-xs sm:text-base text-gray-200 font-medium" data-id="element-66">
                  Recursos listos para usar en clase
                </span>
              </li>
              <li className="flex items-start" data-id="element-67">
                <div className="flex-shrink-0 bg-green-500/20 rounded-full p-0.5 sm:p-1 mr-2 mt-0.5" data-id="element-68">
                  <CheckCircle2Icon className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-[#16a34a]" strokeWidth={3} data-id="element-69" />
                </div>
                <span className="text-xs sm:text-base text-gray-200 font-medium" data-id="element-70">
                  Contenido adaptable a distintos diseños curriculares
                </span>
              </li>
              <li className="flex items-start" data-id="element-71">
                <div className="flex-shrink-0 bg-green-500/20 rounded-full p-0.5 sm:p-1 mr-2 mt-0.5" data-id="element-72">
                  <CheckCircle2Icon className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-[#16a34a]" strokeWidth={3} data-id="element-73" />
                </div>
                <span className="text-xs sm:text-base text-gray-200 font-medium" data-id="element-74">
                  Enfoque pedagógico claro y estructurado
                </span>
              </li>
              <li className="flex items-start" data-id="element-75">
                <div className="flex-shrink-0 bg-green-500/20 rounded-full p-0.5 sm:p-1 mr-2 mt-0.5" data-id="element-76">
                  <CheckCircle2Icon className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-[#16a34a]" strokeWidth={3} data-id="element-77" />
                </div>
                <span className="text-xs sm:text-base text-gray-200 font-medium" data-id="element-78">
                  Ahorro real de tiempo con el sistema completo armado
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}